import { render, staticRenderFns } from "./company-branches.vue?vue&type=template&id=451ba17d&scoped=true&"
import script from "./company-branches.vue?vue&type=script&lang=js&"
export * from "./company-branches.vue?vue&type=script&lang=js&"
import style0 from "./company-branches.vue?vue&type=style&index=0&id=451ba17d&lang=scss&scoped=true&"
import style1 from "./company-branches.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./company-branches.vue?vue&type=style&index=2&id=451ba17d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ba17d",
  null
  
)

export default component.exports
import {QInnerLoading,QSpinnerIos,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInnerLoading,QSpinnerIos,QIcon})
